import React, { createContext, useState, useContext } from "react";
import { fetchProfileApi } from "../services/service";

const ProfileContext = createContext();

function ProfileProvider({ children }) {
  const [profile, setProfile] = useState(null);

  const fetchProfileData = async () => {
    if (profile) return;
    try {
      const candidateData = await fetchProfileApi();
      sessionStorage.setItem("userId", candidateData.id);
      setProfile(candidateData);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  return (
    <ProfileContext.Provider value={{ profile, fetchProfileData, setProfile }}>
      {children}
    </ProfileContext.Provider>
  );
}

const useProfile = () => {
  return useContext(ProfileContext);
};

export { useProfile };
export default ProfileProvider;
